import {take, call, fork, put} from 'redux-saga/effects'
import * as actUploaders from 'actions/uploaders'
import * as actionBtn from 'actions/buttons'
import * as action from 'actions'
import FormData from 'form-data'
import {getProfile} from 'sagas/api/profile'
import {
  getImage
} from 'sagas/api/uploadImage'
import * as api from 'api/uploaders'
import * as actCustomerList from 'actions/customers/list'
import {DO_IMPORT_CUSTOMER} from 'actions/uploaders/constants'
import * as mpCustomerList from 'mixpanel/customers/list'
function wait (millis) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(true)
    }, millis)
  })
}

export function * getImportedStatus () {
  // noinspection InfiniteLoopJS
  while (true) {
    let stop = false
    // noinspection InfiniteLoopJS
    while (!stop) {
      yield call(wait, 5000)
      let profile = yield call(getProfile)
      if (!profile.importing) {
        stop = true
        return true
      }
    }
  }
}

/**
 * Ini kalo direfactor
 * ensure mixpanelnya ikutan direfactor
 */
export function * doImportCustemers () {
  while (true) {
    let request = yield take(DO_IMPORT_CUSTOMER)
    mpCustomerList.customerListImport()
    let {file, hasLoyalty} = request.payload
    yield put(action.sendingRequest(true))
    yield put(action.showLoadingSpinner(true))
    yield put(actionBtn.showLoadingButton(true))
    let response = yield call(getImage, {filename: file.name})
    let formData = new FormData()
    formData.append('key', response.key)
    formData.append('acl', response.acl)
    formData.append('AWSAccessKeyId', response.aws_access_key_id)
    formData.append('success_action_status', response.success_action_status)
    formData.append('Content-Type', response.content_type)
    formData.append('Cache-Control', response.cache_control)
    formData.append('policy', response.policy)
    formData.append('signature', response.signature)
    formData.append('file', file)
    try {
      yield put(actUploaders.showModalImport(false))
      yield call(api.uploadToS3, response.url, formData)
      yield call(api.sendSuccessUploadCustomers, response.fullUrl)
      yield call(api.requestImportDataToCustomers)
      yield put(action.showLoadingSpinner(false))
      yield put(actCustomerList.showImportingModeModal())
      yield call(getImportedStatus)

      let customersReqParam = {page: 1}
      if (hasLoyalty) {
        customersReqParam.type = 'ALL'
      }
      yield put(actCustomerList.customersRequest(customersReqParam, []))
      yield put(actCustomerList.setCustomerDetail(null))
      yield put(actCustomerList.hideImportingModeModal())
    } catch (error) {
      yield put(actUploaders.showModalErrorImport(true, error.data.errors))
      yield put(action.showLoadingSpinner(false))
    } finally {
      yield put(action.sendingRequest(false))
      yield put(actionBtn.showLoadingButton(false))
    }
  }
}

export default function * importCustomers () {
  yield fork(doImportCustemers)
}



// WEBPACK FOOTER //
// ./app/sagas/uploaders/importCustomer.js